import { LoggedInUser, UserRoles } from './users.models';

export function checkPermissions(user: LoggedInUser, roles: UserRoles[]) {
    return (
        roles
            .map((role) => {
                const roleParts = parts(role);

                // check for role with same permission and same or better level
                const roleMatch =
                    user.roles.findIndex((r) => {
                        const permissionMatch = r.startsWith(roleParts.service + '-' + roleParts.permission);
                        const lvlMatch = parts(r).level >= roleParts.level;
                        return permissionMatch && lvlMatch;
                    }) > -1;

                // In addition
                if (roleParts.permission === 'ALL') {
                    // check for crud permissions when asked for permission 'ALL'
                    const hasCrudPermissions =
                        ['GET', 'PUT', 'POST', 'DELETE'].filter(
                            (p) =>
                                user.roles.findIndex(
                                    (r) => r.startsWith(roleParts.service + '-' + p) && parts(r).level >= roleParts.level
                                ) > -1
                        ).length === 4;
                    return roleMatch || hasCrudPermissions;
                } else {
                    // check for 'ALL' permission, because 'ALL' implies GET, DELETE, PUT and POST
                    const hasSuperPermission =
                        user.roles.findIndex((r) => r.startsWith(roleParts.service + '-' + 'ALL') && parts(r).level >= roleParts.level) >
                        -1;

                    return roleMatch || hasSuperPermission;
                }
            })
            .filter((r) => r === false).length === 0
    );
}

function parts(role: string) {
    const roleParts = role.split('-');
    const service = roleParts[0];
    const permission = roleParts[1];
    const level = !Number.isNaN(+roleParts[2]) ? +roleParts[2] : 0;
    return { service, permission, level };
}

export const USER_LANG_KEY = 'lang';
